<template>
    <el-dialog
        :visible.sync="show"
        :append-to-body="true"
        :destroy-on-close="true"
        :width="width + 'px'"
        top="0"
        class="adverts-activate"
        custom-class="adverts-activate"
        @close="close"
    >   
        <!-- <div class="adverts-activate-body" :class="activityData.length <= 1 ? 'hideIndicator' : ''"> -->
        <div class="adverts-activate-body">
            <flip-carousel
                :autoplay="true"
                :items="activityData"
                :height="height"
                :loop="true"
                duration="600"
            >
                <template v-slot="{ item }">
                    <div class="adverts-img-view" @click="close">
                        <div style="position: relative;">
                        <img
                            class="adverts-img"
                            :style="{ height: imgHeight + 'px' }"
                            :src="item.imageUrl"
                            alt=""
                            @click.stop="openAdvertInfo(item)"
                        />
                        <span v-show="item.fileUrl" class="badge-btn"  @click.stop="downloadByLink(item)">{{ item.inputName||'下载' }}</span>
                        <!-- <span class="badge-view" @click.stop="badgeTip">大国工匠   优品推荐</span> -->
                        </div>
                    </div>
                </template>
            </flip-carousel>
            <!-- <el-carousel :height="height + 'px'">
                <el-carousel-item v-for="item in activityData" :key="item.advId">
                    <div class="adverts-img-view" @click="close">
                        <div style="position: relative;">
                            <img class="adverts-img" :style="{ height: imgHeight + 'px' }" :src="item.imageUrl" alt="" @click.stop="openAdvertInfo(item)">
                            <span class="badge-view" @click.stop="badgeTip">大国工匠   优品推荐</span>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel> -->
        </div>

        <whole-confirm ref="wholeConfirmRef"></whole-confirm>
    </el-dialog>
</template>

<script>
import {AdvertsService,UserService} from '@digital-supply-chain/module'
import {ApiService} from '@/service';
import FlipCarousel from './FlipCarousel.vue';

export default {
    components: {
    FlipCarousel,
  },
    data() {
        return {
            show: false,
            activityData: [],

            width: window.innerWidth,
            height: window.innerHeight,

            imgHeight: 0,
        }
    },
    mounted() {
        // 老算法
        // const width = parseInt((window.document.body.clientWidth - 80) / 2, 10);
        // this.imgHeight = window.document.body.clientHeight - (parseInt(width / 3, 10) * 2) - 20;

        const width = parseInt((window.document.body.clientWidth - 80) / 2, 10);
        this.imgHeight = parseInt(width / 2, 10); // 高度 = 宽度 / 2

        this.queryAdverts();
    },
    methods: {
        downloadByLink(item) {
            const link = document.createElement('a');
            link.href = item.fileUrl;
            link.download = item.inputName || '下载文件';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        open() {
            const dialogClose = window.sessionStorage.getItem('advertsActivate');
            if (dialogClose && dialogClose == 1) {
                return false;
            }
            if (this.activityData.length <= 0) {
                return false;
            }
            this.show = true;
        },
        close() {
            window.sessionStorage.setItem('advertsActivate', 1);
            this.show = false;
        },
        openAdvertInfo(adv) {
            // console.log(adv, 'adv------')
            // window.open(adv.targetUrl)
            // return
            AdvertsService.openAdvertInfo(adv.advId, adv.targetUrl);
            this.close();
        },
        async queryAdverts() {
            // const userInfo = UserService.user();
            // if (!['51568','1287'].includes(`${userInfo.CompID}`)) {
            //     return false;
            // }

            const res = await AdvertsService.queryAdverts({
                type: 8,
                limit: 10,
            });
            this.activityData = (res || []).filter(item => item.imageUrl).map(item => {
                item.imageUrl && (item.imageUrl = ApiService.ImageHost + item.imageUrl);
                item.fileUrl && (item.fileUrl = ApiService.ImageHost + item.fileUrl);
                return item;
            });
            this.open();
        },

        badgeTip() {
            this.$refs.wholeConfirmRef.open({
                width: '500px',
                content: `<div>广告招商说明：：<div style="text-indent: 2em;">如果您的产品目标客户是装备制造业广大技术选型工程师，产品品质、技术性能在行业内领先、独创或者位居前列，是直接制造商，特别属于专精特新企业、小巨人企业或者首台套企业，愿意借助本平台面向全国推广、展示、招商，请立即联系平台运营客服，及时将产品信息完善到所属企业站，建立自己的平台网站，方便广大工程师检索了解和咨询。</div></div>`,
                showConfirm: false,
            })
        }
    },
}
</script>

<style lang="less">
    .adverts-activate{
        .adverts-activate-body{
            width: 100vw;
            height: 100vh;
        }
        .adverts-img-view{
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .badge-view{
            position: absolute;
            left: 0;
            bottom: 0;
            padding: 16px 12px;
            font-size: 10px;
            color: #ffc64a;
            cursor: pointer;
        }
        .badge-btn {
            position: absolute;
            left: 20px;
            bottom: 10px;
            padding: 6px 12px;
            font-size: 10px;
            color: #ffc64a;
            cursor: pointer;
            text-decoration: none;
            border: 1px solid #ffc64a;
            border-radius: 25px;
        }
        .adverts-img{
            cursor: pointer;
        }


        .hideIndicator{
            .el-carousel__indicators{
                display: none;
            }
            .el-carousel__arrow{
                display: none!important;
            }
        }
        &.el-dialog{
            background: transparent;
            margin: 0;
        }
        .el-dialog__header{
            position: absolute;
            z-index: 999;
            width: 100%;
            i{
                color: #fff;
            }
        }
        .el-dialog__body{
            padding: 0;
        }
        .el-dialog__footer{
            text-align: center;
            width: 100%;
            display: block;
        }
        .el-dialog__headerbtn{
            top: 100px;
            right: 100px;
            font-size: 26px;
        }
    }
</style>
